export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "edit-market": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
        "market-archive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Archive"])},
        "market-delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])},
        "market-edit-managers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit managers"])},
        "market-name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "options": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Options"])},
        "disabled-market": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate"])},
        "enabled-market": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reactivate"])}
      },
      "fr": {
        "edit-market": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])},
        "market-archive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Archiver"])},
        "market-delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer"])},
        "market-edit-managers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier les gestionnaires"])},
        "market-name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
        "options": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Options"])},
        "disabled-market": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactiver"])},
        "enabled-market": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réactiver"])}
      }
    }
  })
}
